import { nav } from './section/nav'

export const fr_FR = {
    ...nav
};
